/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useGlobal } from '../../../../contexts/Global/context';
import { useTitular } from '../../../../contexts/InclusaoTitular/context';
import { useDependente } from '../../../../contexts/InclusaoDependente/context';

import Accordion from '../../../../components/Accordion';
import StepProgress from '../../../../components/StepProgress';
import Button from '../../../../components/Button';
import InputInfo from '../../../../components/Inputs/Info';
import FormContainer from '../../../../components/FormContainer';

import { buscarArquivo, adicionarDependente, adicionarTitular } from '../../../../services';

import { createPayloadDependente, createPayloadTitular } from './payloads';

import steps from '../../../../utils/steps.json';
import { cloneObject, handleTopCritics, calculoImc, checkIsSupport } from '../../../../utils';

import MensagensAlertas from '../Alertas';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

import * as S from './styles';

function RevisarDados() {
    const history = useHistory();

    const { setDataTitular, dataTitular, flow, othersDocuments, setAlerts } = useTitular();
    const { setDataDependentes, dataDependentes } = useDependente();
    const { dataActiveContract, setShowSupportModal } = useGlobal();

    const [loadingAddBeneficiario, setLoadingAddBeneficiario] = useState(false);

    const hasTitular = flow === 'adicionar_titular';

    useEffect(() => {
        if (!dataTitular.cpf) history.push('/movimentacao_cadastral/adicionar_beneficiario');
    }, []);

    async function handleAddBeneficiarios() {
        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        const dataMovimentacaoTitular = dataTitular.dataMovimentacao || {};

        let hasProblems = false;
        let payloadTitular = dataMovimentacaoTitular;
        let movimentacaoTitular = {};

        setLoadingAddBeneficiario(true);

        dataTitular.documents.push(...othersDocuments);

        const documentsTitularRequests = dataTitular.documents.map(async (doc) => {
            const { id: tipoArquivo, name: nomeArquivo } = doc;

            return buscarArquivo({
                cpfCnpj: dataTitular.cpf.unmaskedValue,
                numeroContrato: dataActiveContract.numero,
                tipoArquivo,
                nomeArquivo,
            });
        });

        const documentsTitularResponse = await Promise.all(documentsTitularRequests);

        if (hasTitular) {

            payloadTitular = createPayloadTitular(
                dataActiveContract,
                dataMovimentacaoTitular,
                dataTitular,
                documentsTitularResponse.flat()
            );

            const responseTitular = await adicionarTitular(payloadTitular);

            if (responseTitular.errorDescription) {
                responseTitular.movimentacoes = [
                    {
                        criticas: [
                            {
                                tipo: 1,
                                descricao: responseTitular.errorDescription,
                                codigo: '#DEFAULT_ERROR',
                            },
                        ],
                    },
                ];
            }

            const movimentacao = responseTitular.movimentacoes[0];
            const criticas = handleTopCritics(movimentacao.criticas);

            movimentacaoTitular = {
                sequencialMovimentacao: movimentacao.sequencialMovimentacao,
                codigoSituacaoMovimentacao: movimentacao.codigoSituacaoMovimentacao,
            };

            const cloneDataTitular = cloneObject(dataTitular);

            cloneDataTitular.dataMovimentacao = movimentacaoTitular;

            setDataTitular(cloneDataTitular);

            if (criticas.length > 0) {
                hasProblems = true;

                setAlerts([...criticas]);

                setTimeout(() => {
                    window.document.getElementById('page-content').scrollTo(0, 0);
                }, 100);

                return;
            }
        }

        if (dataDependentes.length > 0) {
            const movimentacoesDependentes = [];

            for (const [indexDependente, dependente] of dataDependentes.entries()) {

                if (!hasTitular) dependente.documents.push(...othersDocuments);

                const documentsDependenteRequests = dependente.documents.map(async (doc) => {
                    const { id: tipoArquivo, name: nomeArquivo } = doc;

                    return buscarArquivo({
                        cpfCnpj: dependente.cpf.unmaskedValue.toString(),
                        numeroContrato: dataActiveContract.numero,
                        tipoArquivo,
                        nomeArquivo,
                    });
                });

                const documentsDependenteResponse = await Promise.all(documentsDependenteRequests);

                const payloadDependente = createPayloadDependente(
                    dataActiveContract,
                    flow,
                    movimentacaoTitular,
                    dataTitular,
                    dependente,
                    documentsDependenteResponse.flat()
                );

                const responseDependente = await adicionarDependente(payloadDependente);

                if (responseDependente.errorDescription || responseDependente[0]?.errorDescription) {
                    responseDependente.movimentacoes = [
                        {
                            criticas: [
                                {
                                    tipo: 1,
                                    descricao:
                                        responseDependente.errorDescription || responseDependente[0]?.errorDescription,
                                },
                            ],
                        },
                    ];
                }

                const movimentacao = responseDependente.movimentacoes[0];
                const criticas = handleTopCritics(movimentacao.criticas);

                movimentacoesDependentes.push({
                    indexDependente,
                    sequencialMovimentacao: movimentacao.sequencialMovimentacao,
                    codigoSituacaoMovimentacao: movimentacao.codigoSituacaoMovimentacao,
                });

                if (criticas.length > 0) {
                    hasProblems = true;

                    setAlerts([...criticas]);

                    setTimeout(() => {
                        window.document.getElementById('page-content').scrollTo(0, 0);
                    }, 100);

                    break;
                }
            }

            const cloneDataDependente = cloneObject(dataDependentes);

            movimentacoesDependentes.forEach((movimentacao) => {
                cloneDataDependente[movimentacao.indexDependente].dataMovimentacao = movimentacao;
            });

            setDataDependentes(cloneDataDependente);
        }

        setLoadingAddBeneficiario(false);

        // Se nao tiver nenhuma critica OU se as criticas forem so alertas E o usario ja clicou uma vez em confirmar e ta renviando mesmo com criticas
        if (!hasProblems) history.push('/movimentacao_cadastral/validar_inclusao_beneficiario');
    }

    function renderDocuments(documents) {
        const distinctDocumentsTypes = Array.from(new Set(documents.map((document) => document.id)));

        return distinctDocumentsTypes.map((doc) => {
            const docsByType = documents.filter((document) => document.id === doc);

            if (docsByType.length === 0) return <></>;

            const fieldValue = (
                <ul>
                    {docsByType.map((document, index) => (
                        <li key={() => `${document.name}-${index + 1}`}>{document.name}</li>
                    ))}
                </ul>
            );

            return (
                <InputInfo
                    key={docsByType[0].label}
                    field={{
                        type: 'text',
                        label: docsByType[0].label,
                        value: fieldValue || [],
                    }}
                />
            );
        });
    }

    function renderCID(cid) {
        const fieldValue = <div>{cid.value.map((elem) => elem.codigoInternacionalDoenca).join(', ')}</div>;
        return (
            <InputInfo
                key={cid.label}
                field={{
                    type: 'text',
                    label: cid.label,
                    value: fieldValue || [],
                }}
            />
        );
    }

    function HeaderAddTitular() {
        return (
            <S.ContentData>
                <S.SpacingReviewDown>
                    <Accordion title="Dados para o plano" hasCollapse={false} />
                    <FormContainer>
                        <InputInfo field={dataTitular.company} />
                        <InputInfo field={dataTitular.healthPlan} />
                        <InputInfo field={dataTitular.dateStartPlan} />
                        <InputInfo field={dataTitular.lackGroup} />
                        <InputInfo field={dataTitular.countyService} />
                        <InputInfo field={dataTitular.stateService} />
                        <InputInfo field={dataTitular.congenerName} />
                    </FormContainer>
                </S.SpacingReviewDown>

                <S.SpacingReviewDown>
                    <Accordion title="Dados profissionais" hasCollapse={false} />
                    <FormContainer>
                        <InputInfo field={dataTitular.occupation} />
                        <InputInfo field={dataTitular.admissionDate} />
                        <InputInfo field={dataTitular.functionalStatus} />
                        <InputInfo field={dataTitular.enrollmentSequence} />
                        <InputInfo field={dataTitular.functionalEnrollment} />
                        <InputInfo field={dataTitular.startCapacity} />
                        <InputInfo field={dataTitular.capacity} />
                        <InputInfo field={dataTitular.costCenter} />
                        <InputInfo field={dataTitular.startDate} />
                    </FormContainer>
                </S.SpacingReviewDown>

                <S.SpacingReviewDown>
                    <Accordion title="Dados de titular" hasCollapse={false} />
                    <FormContainer>
                        <InputInfo field={dataTitular.cpf} />
                        <InputInfo field={dataTitular.nationality} />
                        <InputInfo field={dataTitular.fullName} />
                        <InputInfo field={dataTitular.socialName} />
                        <InputInfo field={dataTitular.birth} />
                        <InputInfo field={dataTitular.gender} />
                        <InputInfo field={dataTitular.motherName} />
                        <InputInfo field={dataTitular.civilState} />
                        <InputInfo field={dataTitular.pis} />
                        <InputInfo field={dataTitular.sus} />
                        <InputInfo field={dataTitular.dn} />
                    </FormContainer>
                </S.SpacingReviewDown>

                <S.SpacingReviewDown>
                    <Accordion title="Dados de contato" hasCollapse={false} />
                    <FormContainer>
                        <InputInfo field={dataTitular.cep} />
                        <InputInfo field={dataTitular.addressNumber} />
                        <InputInfo field={dataTitular.address} />
                        <InputInfo field={dataTitular.hood} />
                        <InputInfo field={dataTitular.complement} />
                        <InputInfo field={dataTitular.uf} />
                        <InputInfo field={dataTitular.city} />
                        <InputInfo field={dataTitular.cellphone} />
                        <InputInfo field={dataTitular.email} />
                    </FormContainer>
                </S.SpacingReviewDown>

                {((dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired) ||
                    dataActiveContract.isAdesao ||
                    dataActiveContract.isPme) && (
                        <S.SpacingReviewDown>
                            <Accordion title="Dados de sáude" hasCollapse={false} />
                            <FormContainer>
                                {dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired && (
                                    <>
                                        <InputInfo field={dataTitular.weight} />
                                        <InputInfo
                                            field={{
                                                label: 'Índice de massa corporal (IMC)',
                                                value: `${calculoImc(
                                                    dataTitular.weight?.value,
                                                    dataTitular.height?.value
                                                )} kg/m2`,
                                                type: 'text',
                                            }}
                                        />
                                    </>
                                )}
                                <InputInfo field={dataTitular.height} />
                                {dataTitular.cid.value?.length > 0 && renderCID(dataTitular.cid)}
                            </FormContainer>
                        </S.SpacingReviewDown>
                    )}

                {dataTitular.documents.length > 0 && (
                    <Accordion title="Documentos anexados" hasCollapse={false}>
                        <FormContainer>{renderDocuments(dataTitular.documents)}</FormContainer>
                    </Accordion>
                )}
            </S.ContentData>
        );
    }

    function HeaderSelectTitular() {
        return (
            <S.ContentData>
                <Accordion title="Dados de titular" hasCollapse={false}>
                    <FormContainer>
                        <InputInfo field={dataTitular.cardNumber} />
                        <InputInfo field={dataTitular.fullName} />
                        <InputInfo field={dataTitular.company} />
                    </FormContainer>
                </Accordion>
            </S.ContentData>
        );
    }

    return (
        <PageContainer>
            <StepProgress steps={steps.inclusaoDependentes} activeStep={4} />

            <MensagensAlertas />

            {hasTitular ? <HeaderAddTitular /> : <HeaderSelectTitular />}

            {dataDependentes.map((dependente, indexDep) => (
                <S.ContentData key={`dependente-${indexDep}`}>
                    <Accordion
                        title={`Dados de dependente - ${(indexDep + 1).toString().padStart(2, '0')}`}
                        hasCollapse={false}
                    >
                        <FormContainer>
                            <InputInfo field={dependente.healthPlan} />
                            <InputInfo field={dependente.dateStartPlan} />

                            <InputInfo field={dependente.cpf} />
                            <InputInfo field={dependente.nationality} />
                            <InputInfo field={dependente.fullName} />
                            <InputInfo field={dependente.socialName} />
                            <InputInfo field={dependente.gender} />

                            <InputInfo field={dependente.motherName} />
                            <InputInfo field={dependente.civilState} />
                            <InputInfo field={dependente.kinshipDegree} />
                            <InputInfo field={dependente.pis} />
                            <InputInfo field={dependente.sus} />
                            <InputInfo field={dependente.dn} />
                            <InputInfo field={dependente.enrollmentSequence} />
                        </FormContainer>
                    </Accordion>

                    {((dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired) ||
                        dataActiveContract.isAdesao ||
                        dataActiveContract.isPme) && (
                            <S.SpacingReviewDown>
                                <Accordion title="Dados de sáude" hasCollapse={false} />
                                <FormContainer>
                                    {dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired && (
                                        <>
                                            <InputInfo field={dependente.weight} />
                                            <InputInfo
                                                field={{
                                                    label: 'Índice de massa corporal (IMC)',
                                                    value: `${calculoImc(
                                                        dependente.weight?.value,
                                                        dependente.height?.value
                                                    )} kg/m2`,
                                                    type: 'text',
                                                }}
                                            />
                                        </>
                                    )}
                                    <InputInfo field={dependente.height} />
                                    {dependente.cid.value?.length > 0 && renderCID(dependente.cid)}
                                </FormContainer>
                            </S.SpacingReviewDown>
                        )}

                    {dependente.documents.length > 0 && (
                        <Accordion title="Documentos anexados" hasCollapse={false}>
                            <FormContainer>{renderDocuments(dependente.documents)}</FormContainer>
                        </Accordion>
                    )}
                </S.ContentData>
            ))}

            {othersDocuments.length > 0 && (
                <S.ContentData>
                    <Accordion title="Documentos complementares" hasCollapse={false}>
                        <FormContainer>{renderDocuments(othersDocuments)}</FormContainer>
                    </Accordion>
                </S.ContentData>
            )}
            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    loading={loadingAddBeneficiario}
                    disabled={loadingAddBeneficiario}
                    onClick={handleAddBeneficiarios}
                >
                    Continuar
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default RevisarDados;
